import { IsDate, IsEnum, IsInt, IsNumber, IsUUID } from 'class-validator';

import { OrderStatus } from './order-status';

export class PublicOrderDTO {
    @IsInt()
    public id: number;

    @IsUUID()
    public uuid: string;

    @IsDate()
    public createdAt: Date;

    @IsNumber()
    public sum: number;

    @IsEnum(OrderStatus)
    public status: OrderStatus;

    constructor(data?: Partial<PublicOrderDTO>) {
        this.id = data?.id;
        this.uuid = data?.uuid;
        this.createdAt = data?.createdAt;
        this.sum = data?.sum ?? 0;
        this.status = data?.status;
    }
}
